module.exports = __webpack_public_path__ + "static/img/tip-3.8baa16f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/usdt5/tip-3.png
// module id = JCrt
// module chunks = 1